import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core';

import { Grid } from '../../../lib/grid';
import { Row } from '../../../lib/data-set/row';

@Component({
    selector: '[ng2-st-thead-form-row]',
    template: `
      @if (isMultiSelectVisible) {
        <td></td>
      }
      @if (showActionColumnLeft) {
        <td class="ng2-smart-actions">
          <ng2-st-actions [grid]="grid" [row]="row" (create)="onCreate($event)" (addCancel)="addCancel.emit($event)">
          </ng2-st-actions>
        </td>
      }
      @for (cell of grid.getNewRow().getCells(); track cell) {
        <td>
          <ng2-smart-table-cell [cell]="cell" [grid]="grid" [isNew]="true" [createConfirm]="createConfirm"
                                [inputClass]="addInputClass" [isInEditing]="grid.getNewRow().isInEditing"
                                (edited)="onCreate($event)">
          </ng2-smart-table-cell>
        </td>
      }
      @if (showActionColumnRight) {
        <td class="ng2-smart-actions">
          <ng2-st-actions [grid]="grid" [row]="row" (create)="onCreate($event)" (addCancel)="addCancel.emit($event)">
          </ng2-st-actions>
        </td>
      }
    `,
    standalone: false
})
export class TheadFormRowComponent implements OnChanges {
  @Input() public grid: Grid;
  @Input() public row: Row;
  @Input() public createConfirm: EventEmitter<any>;

  @Output() public create = new EventEmitter<any>();
  @Output() public addCancel = new EventEmitter<any>();

  public isMultiSelectVisible: boolean;
  public showActionColumnLeft: boolean;
  public showActionColumnRight: boolean;
  public addInputClass: string;

  public onCreate(event: any) {
    event.stopPropagation();

    this.grid.create(this.grid.getNewRow(), this.createConfirm);
  }

  public ngOnChanges() {
    this.isMultiSelectVisible = this.grid.isMultiSelectVisible();
    this.showActionColumnLeft = this.grid.showActionColumn('left');
    this.showActionColumnRight = this.grid.showActionColumn('right');
    this.addInputClass = this.grid.getSetting('add.inputClass');
  }
}
